export const TAG_PRIORITY = {
  BACK_IN_STOCK_TAG: 'Back in stock',
  LOW_STOCK_TAG: 'Low Stock',
  SOLD_OUT_TAG: 'Sold Out',
  NEW_TAG: 'New',
  LAST_CHANCE: 'Leaving Soon',
  PRE_ORDER_TAG: 'Preorder',
  PRE_ORDER_TAG_WITH_SPACE: 'Pre Order',
  BEST_SELLER: 'Best seller',
  BUNDLE_TAG: 'Bundle and Save',
  SALE_TAG: 'Save %',
  EARN_CREDIT_TAG: 'Earn $',
}
